type MetaGroups = 'group1' | 'group2' | 'group3';

const richMetaTestGroups: Record<string, MetaGroups> = {
	'/de/film/das-camp-des-grauens-2': 'group1',
	'/de/film/bai-se-bai-he': 'group1',
	'/de/film/somewhere-else-together': 'group1',
	'/de/film/der-ritter-der-apokalypse': 'group1',
	'/de/serie/wonder-pets-in-der-stadt': 'group1',
	'/de/film/sierra-charriba': 'group1',
	'/de/film/sie-sind-frei-dr-korczak': 'group1',
	'/de/film/der-scout': 'group1',
	'/de/film/whale': 'group1',
	'/de/serie/das-leben-ist-schoen': 'group1',
	'/de/film/en-attendant-bojangles': 'group1',
	'/de/film/klein-erna-auf-dem-jungfernstieg': 'group1',
	'/de/film/lloyd': 'group1',
	'/de/film/the-midnight-man': 'group1',
	'/de/serie/boy-swallows-universe': 'group1',
	'/de/serie/fidelity': 'group1',
	'/de/film/the-district': 'group1',
	'/de/film/altersgluehen-speed-dating-fuer-senioren': 'group1',
	'/de/film/gefangene-der-zeit': 'group1',
	'/de/film/despicable-me-2-3-mini-movie-collection': 'group1',
	'/de/film/pixars-komplette-kurzfilm-collection-volume-2-presto': 'group2',
	'/de/film/goldilocks-and-the-three-bears-death-and-porridge': 'group2',
	'/de/film/magic-stocking': 'group2',
	'/de/film/sechs-auf-einen-streich-das-maerchen-von-der-zauberfloete': 'group2',
	'/de/film/pup-star-world-tour': 'group2',
	'/de/film/auf-das-was-wir-lieben': 'group2',
	'/de/film/zwei-freunde': 'group2',
	'/de/film/sparkle': 'group2',
	'/de/film/demonic': 'group2',
	'/de/film/i-claude-monet': 'group2',
	'/de/film/cinco-lobitos': 'group2',
	'/de/film/safari-match-me-if-you-can': 'group2',
	'/de/film/i-will-never-leave-you-alone': 'group2',
	'/de/serie/moors-murders': 'group2',
	'/de/serie/die-maske-der-koenigin': 'group2',
	'/de/film/generation-iron-2': 'group2',
	'/de/film/triage': 'group2',
	'/de/film/shoguns-ninja': 'group2',
	'/de/film/huekuemet-kadin-2': 'group2',
	'/de/film/robin-williams-come-inside-my-mind': 'group2',
	'/de/serie/ill-be-gone-in-the-dark': 'group3',
	'/de/film/das-geheimnis-im-moor': 'group3',
	'/de/film/hilary-und-jackie': 'group3',
	'/de/film/uninvited-2024': 'group3',
	'/de/film/maiden': 'group3',
	'/de/film/simple-men': 'group3',
	'/de/film/the-beatles-now-and-then': 'group3',
	'/de/film/kinderschaender-im-visier': 'group3',
	'/de/film/that-they-may-face-the-rising-sun': 'group3',
	'/de/film/ardennen-1944': 'group3',
	'/de/serie/true-love-or-true-lies': 'group3',
	'/de/film/los-fuertes': 'group3',
	'/de/film/ruslan-und-ljudmila': 'group3',
	'/de/film/corina': 'group3',
	'/de/film/hot-air': 'group3',
	'/de/film/django-und-die-bande-der-bluthunde': 'group3',
	'/de/serie/gugayi-seo': 'group3',
	'/de/film/frankenstein-das-experiment': 'group3',
	'/de/film/der-einstein-des-sex': 'group3',
	'/de/film/alex-pandian': 'group3',
};

export function getRichMetaDescriptions(title: string, path: string) {
	const group = richMetaTestGroups[path.toLowerCase()];

	if (!group) return null;

	return richMetaDescriptionsByGroup()[group](title);
}

function richMetaDescriptionsByGroup(): Record<MetaGroups, (title: string) => string> {
	return {
		group1: (title: string) =>
			`Finde heraus, wie und wo du 🎬 ${title} auf Streaming-Diensten wie · Netflix · Prime Video · Disney+ sehen kannst - inkl. Free & 4K Optionen!`,
		group2: (title: string) =>
			`Finde heraus, wie und wo du ⭐ ${title} auf Streaming-Diensten wie ➤ Netflix ➤ Prime Video ➤ Disney+ sehen kannst - inkl. Free & 4K Optionen!`,
		group3: (title: string) =>
			`Finde heraus, wie und wo du ☆ ${title} auf Streaming-Diensten wie ᐅ Netflix ᐅ Prime Video ᐅ Disney+ sehen kannst - inkl. Free & 4K Optionen!`,
	};
}
